
console.log('init_tvprogram.js loaded!');

/* css for the specific page */
import "./pages-assets/tvprogram/tvprogram.css";


   

/* scripts for the specific page */
import "./pages-assets/tvprogram/tvprogram.js";